var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAiIcon = function SvgAiIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1012 5.71429L19.0097 3.75238L21.0007 2.85714L19.0097 1.9619L18.1012 0L17.1927 1.9619L15.2018 2.85714L17.1927 3.75238L18.1012 5.71429Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.98669 5.71429L7.89518 3.75238L9.88613 2.85714L7.89518 1.9619L6.98669 0L6.0782 1.9619L4.08725 2.85714L6.0782 3.75238L6.98669 5.71429Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1012 10.9524L17.1927 12.9143L15.2018 13.8095L17.1927 14.7048L18.1012 16.6667L19.0097 14.7048L21.0007 13.8095L19.0097 12.9143L18.1012 10.9524Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.888 7.73333L13.1528 5.03809C12.9595 4.85714 12.7179 4.7619 12.4666 4.7619C12.2153 4.7619 11.9737 4.85714 11.7804 5.03809L0.984844 15.6762C0.607917 16.0476 0.607917 16.6476 0.984844 17.019L3.71998 19.7143C3.91328 19.9048 4.1549 20 4.40618 20C4.65747 20 4.89909 19.9048 5.09239 19.7238L15.888 9.08571C16.2649 8.71429 16.2649 8.10476 15.888 7.73333ZM12.4666 7.06667L13.8294 8.40952L12.6986 9.52381L11.3358 8.18095L12.4666 7.06667ZM4.40618 17.7048L3.04345 16.3619L9.97311 9.52381L11.3358 10.8667L4.40618 17.7048Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAiIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "ai-icon.ae0c59d0b7b52851ec6ec40aa13c9a94.svg";